import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getFileById } from '../../controller';
import { toast } from 'react-toastify';


function SelectdownloadFormat({ formId }) {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDownload = async (fileType) => {
        try {
            const res = await getFileById(fileType, formId); // Call the updated function
            const url = URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.download = `${formId}.${fileType}`; // Set the file name and extension
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url); // Free up memory
            toast.success("Success! Your file has been downloaded");
        } catch (error) {
            console.error('Download error:', error);
            toast.error("File not found");
        }
    };


    return (
        <>

            <OverlayTrigger
                key="tooltip"
                placement="top"
                overlay={<Tooltip id={`tooltip-top`}>Download</Tooltip>}
            >
                <button className='border-0' onClick={handleShow}>
                    <img src="../images/png/download.png" alt="" />
                </button>
            </OverlayTrigger>

            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body className='position-relative'>
                    <div className='position-absolute top-0 end-0 me-4 mt-3 cursor-pointer' onClick={handleClose}>
                        <img src="../images/png/close.png" width={12.55} height={12.55} alt="" />
                    </div>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Select Format</h2>
                            </div>
                        </div>

                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <div className='row row-cols-4 select-format-file'>
                                <div className="col"
                                    onClick={() => handleDownload('pdf')}
                                    style={{ cursor: 'pointer' }}>
                                    <div className='d-flex justify-content-center'>
                                        <div>
                                            <img src="../images/png/pdf.png" width={37.26} height={47.61} alt="" />
                                            <p>pdf</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col"
                                    onClick={() => handleDownload('docx')}
                                    style={{ cursor: 'pointer' }}>
                                    <div className='d-flex justify-content-center'>
                                        <div>
                                            <img src="../images/png/docx.png" width={37.26} height={47.61} alt="" />
                                            <p>docx</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col"
                                    onClick={() => handleDownload('xlsx')}
                                    style={{ cursor: 'pointer' }}>
                                    <div className='d-flex justify-content-center'>
                                        <div>
                                            <img src="../images/png/xlsx.png" width={47.85} height={47.85} alt="" />
                                            <p>xlsx</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col"
                                    onClick={() => handleDownload('pptx')}
                                    style={{ cursor: 'pointer' }}>
                                    <div className='d-flex justify-content-center'>
                                        <div>
                                            <img src="../images/png/ppt.png" width={44.35} height={47.85} alt="" />
                                            <p>ppt</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SelectdownloadFormat